export default (hotkeysManager) => () => {
  hotkeysManager.on();
};